import {Injectable, EventEmitter} from '@angular/core';
import {default_name, default_domain} from '../../settings/cookies';
import {CookieService} from "ngx-cookie-service";
import {
    UserCookTokenCheckRequest, UserSession, UserLogOutRequest, HttpOptions,
    UserCredentials
} from "../modele/authModel";
// import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {User, GetCurrentUserResponse} from "../modele/user/userModel";
import {BackendService} from "./api/backend.service";
import {NGXLogger} from "ngx-logger";
import {UserSettings} from "../modele/user/userSettings";
import {interval, Subject, of, from, Observable, Subscription} from 'rxjs';

import async from 'async';
import {Router} from "@angular/router";
import {SocialUser} from "angularx-social-login";

@Injectable({
    providedIn: 'root'
})
export class UserService {

    private log_prefix = this.constructor.name + "2:";
    private user: User;
    private userSession: UserSession;
    private httpOptions: HttpOptions;
    private userEmitter: EventEmitter<User> = new EventEmitter<User>();
    private userSubject: Subject<User> = new Subject();
    private haveUserInServiceSubject: Subject<boolean> = new Subject();
    private userSessionSubject: Subject<UserSession> = new Subject();
    private backendHttpOptionsSubject: Subject<HttpOptions> = new Subject();
    private maxRetries: number = 1;
    private unsureIfHaveUser: boolean = true;
    private changeDetectionSubject: Subject<string> = new Subject();
    private redirectDelayCounter = 5;
    private redirectIntervalCheckSubscription: Subscription;

    constructor(private cookieService: CookieService,
                private http: HttpClient,
                private bes: BackendService,
                private logger: NGXLogger,
                private router: Router,
                // private imageUploadService: ImageFileUploadService
    ) {
        this.logger.info(this.log_prefix, "cons called", this.getUserBearerTokenFromCookie());
        this.resolveUserSessionFromCookieToken();

        this.userSubject.subscribe(user => {
            this.logger.info(this.log_prefix, "self sub -> got user:", user);
            if (this.user == null || this.user.user_id == -1) {
                this.logger.info(this.log_prefix, "self sub -> saving new user[", user.user_id, "]/[",user.user_name,"]");
                this.user = user;
                this.unsureIfHaveUser = false;
            }
            this.maxRetries = 0;
        });
        this.haveUserInServiceSubject.subscribe(newState => {
            this.logger.info(this.log_prefix, "self sub -> got haveUserInServiceSubject:", newState);

            if(newState === false){
                this.logger.info(this.log_prefix,"self sub -> killing user");
                this.user = new User();
                this.unsureIfHaveUser = true;
                this.maxRetries = 1;
            } else {
                this.logger.info(this.log_prefix, "self sub -> got informed of state[",newState,"] -> have valid user:",this.haveValidUserInService());
            }
        });

        this.backendHttpOptionsSubject.subscribe(httpOptionsBasedOnUserSession => {
            this.logger.info(this.log_prefix,"self sub -> got http options for backend");
        });

        this.serviceInterfaceToInformOfChanges().subscribe(serviceThatRequestedChange => {
            this.logger.info(this.log_prefix,"service [",serviceThatRequestedChange,"]requested change");
            this.resolveUserFromUserSession();
        });

        this.redirectIntervalCheckSubscription = interval(1000).subscribe(event => {
            if(this.redirectDelayCounter > 0){
                if(this.haveValidUserInService() === true){
                    this.redirectIntervalCheckSubscription.unsubscribe();
                }
            } else {
                this.haveUserInServiceAndRedirect();
                this.redirectIntervalCheckSubscription.unsubscribe();
            }

            this.redirectDelayCounter -= 1;
        });

        // if (this.haveUserInServiceAndRedirect()) {

    }

    logIn(userCredentials: UserCredentials, callback: Function): Observable<UserSession> {
        let lp = this.log_prefix + "login:";
        let userLoginObservable: Observable<UserSession> = new Observable<UserSession>((observer) => {
            let requestData = {
                userName: userCredentials.user_name,
                userPass: userCredentials.user_pass
            };
            this.http.post<UserSession>(this.bes.getBackendUserLoginUrl(), requestData).subscribe(userSession => {
                    let parsedSession = new UserSession(userSession);
                    this.writeCookie(userSession.token, new Date(userSession.expire));
                    this.userSession = new UserSession({
                        token: parsedSession.token,
                        expire: parsedSession.expire,
                        ttl: parsedSession.ttl
                    });
                    this.unsureIfHaveUser = false;
                    this.logger.info(lp,"successfully resolved userSession via login:",this.userSession.ttl," attempting user resolution");
                    this.haveUserInServiceSubject.next(true);
                    observer.next(this.userSession);
                    this.resolveUserFromUserSession();
                    return callback(null, this.userSession)
                },
                error => {
                    this.logger.warn(this.log_prefix, "have errors trying to login via credentials:", error.message);
                    return callback(error);
                });
        });
        return userLoginObservable;
    }

    private resolveUserSessionFromCookieToken(): void {
        let lp=this.log_prefix+"resolveUserSessionFromCookieToken:";
        this.logger.info(lp, "called at[", new Date(), "]");
        async.waterfall([
            done => {
                return done(null, this.getUserBearerTokenFromCookie());
            },
            (cookieToken, done) => {
                // this.logger.info(this.log_prefix,"cookie token:",cookieToken)
                return done(null, cookieToken, this.haveValidCookieToken(cookieToken))
            },
            (cookieToken, cookieTokenLooksValid, done) => {
                this.logger.info(this.log_prefix, "cookie token cookieTokenLooksValid:", cookieTokenLooksValid)
                if (cookieTokenLooksValid === true) {
                    this.logger.info(this.log_prefix, "cookie contains a checkable token:", cookieToken);
                    return done(null, cookieToken, cookieTokenLooksValid);
                }
                // return done(new Error("bla"));
                return done(null, cookieToken, false);
            },
            (cookieToken, cookieTokenLooksValid, done) => {
                if (cookieTokenLooksValid === true) {

                    return this.createUserSessionFromToken(cookieToken, (err, cookieIsValid, cookieBasedSession) => {
                        if (err) {
                            return done(err);
                        }
                        // this.logger.info(this.log_prefix, "cookieIsValid:", cookieIsValid, "created userSession:", this.userSession)
                        this.userSession = cookieBasedSession;
                        return done(null, this.userSession.ttl > 0, this.userSession)
                    })
                } else {
                    this.logger.info(this.log_prefix,"failure to automatically create user session from cookie")
                    return done(null, false, new UserSession())
                }
            }
        ], (resolveUserSessionCookieErr, successful_resolution, resolvedUserSession)=>{
            if(resolveUserSessionCookieErr){
                this.logger.warn(this.log_prefix,"have error trying to resolve existing session from cookie:",resolveUserSessionCookieErr.message);
                throw new Error(resolveUserSessionCookieErr);
            }
            if(successful_resolution === true){
                this.logger.info(this.log_prefix,"successfully resolved user session:",resolvedUserSession.ttl);
                this.maxRetries = 0;
                this.unsureIfHaveUser = false;
                this.resolveUserFromUserSession();
                this.haveUserInServiceSubject.next(true);
            } else {
                this.logger.info(this.log_prefix,"failure to resolve user session from cookie -> retry in 1 second");
                setTimeout(()=>{
                    if(this.maxRetries > 0){
                        this.resolveUserSessionFromCookieToken();
                        this.maxRetries -= 1;
                    } else {
                        this.unsureIfHaveUser = false;
                        this.haveUserInServiceSubject.next(false);
                    }
                },1000)
            }
        });
    }

    private resolveUserFromUserSession() {
        this.logger.info(this.log_prefix, "called at[", new Date(), "] ttl:",this.userSession.ttl);
        this.userSessionSubject.next(this.userSession);
        this.backendHttpOptionsSubject.next(this.setupHttpOpts(this.userSession));
        async.waterfall([
            done => {
                return this.getCurrentUserWithUserSession((err, user) => {
                    if (err) {
                        this.logger.info(this.log_prefix, "have error after trying to create user from user session:", err.message);
                        return done(err);
                    }
                    // this.logger.info(this.log_prefix,"resolved user from cookie token:",user.user_name);
                    this.user = user;
                    this.unsureIfHaveUser = false;
                    this.maxRetries = 0;
                    return done(null, user)
                });
            }

        ], (err, userBehindToken) => {
            if (err) {
                this.logger.error(this.log_prefix + " have error in waterfall to auto login via cookie:", err.message);
                throw err;
            }

            this.logger.info(this.log_prefix,
                //"have token:",token,
                // "created userSession:", this.userSession +"\n",
                "tokenRepresentsUser:", userBehindToken.user_name);

            this.userSubject.next(userBehindToken);
            if(this.userSession.ttl > 0){

                this.haveUserInServiceAndRedirect()
            }
        });
    }

    public haveValidUserSession(userSession?: UserSession): boolean {
        if (userSession != null) {
            if (userSession != null) {
                let {ttl} = userSession;
                if (ttl >= 1) {// todo maybe switch this with session_duration_threshold
                    return true;
                }
            }
        } else {
            if (this.userSession != null) {
                let {ttl} = this.userSession;
                if (ttl >= 1) {// todo maybe switch this with session_duration_threshold
                    return true;
                }
            }
        }

        return false;
    }

    private haveValidCookieToken(cookieToken: string): boolean {
        if (
            (cookieToken != null) &&
            (typeof cookieToken == "string") &&
            (cookieToken.length > 0)) {
            return true;
        }
        return false;
    }

    public haveValidUserInService(): boolean {

        if ((this.user != null) && this.user.user_id != -1) {
            // this.logger.info(this.log_prefix, "have valid user:", typeof this.user, this.user.user_name);
            this.logger.info(this.log_prefix, "[",this.redirectDelayCounter,"] have valid user:", this.user.user_id);
            return true;
        }
        this.logger.info(this.log_prefix, "[",this.redirectDelayCounter,"] dont have valid user:");
        return false;
    }


    // todo make private and kill
    public userCouldBeResolvedFromCookieToken(): Observable <boolean> {
        return new Observable((observer) => {
            observer.next(false);
        });
    }

    private createUserSessionFromToken(tokenToCreateSession: string, callback: Function): boolean {
        //private createUserSessionFromToken(): Observable<UserCookTokenCheckRequest> {
        let lp = this.log_prefix + "createUserSessionFromToken:";
        if (typeof callback != "function") {
            throw new Error(lp + "invalid input: missing callback function");
        }

        this.logger.info(lp, "called");

        let cookieSession = new UserSession({token: tokenToCreateSession, ttl: -1, expire: ""});
        if (this.haveValidCookieToken(tokenToCreateSession) === true) {
            // this.logger.info(lp, "setup cookie session:", cookieSession);
            this.http.get<UserCookTokenCheckRequest>(this.bes.getBackendTokenIsValidUrl(), this.setupHttpOpts(cookieSession)).subscribe(UserCookTokenCheckRequest => {
                let {status} = UserCookTokenCheckRequest;
                let {message} = UserCookTokenCheckRequest;
                let {ttl} = UserCookTokenCheckRequest;
                let {token} = UserCookTokenCheckRequest;
                let {lifeTime} = UserCookTokenCheckRequest;
                // this.logger.info(lp,"have feedback from backend:",Object.keys(UserCookTokenCheckRequest), UserCookTokenCheckRequest);
                let cookieBasedSession = new UserSession({token, ttl, expire: ""}); // todo: add expiry timestamp

                // this.logger.info(lp, "have cookie based session:", cookieBasedSession);
                if (this.haveValidUserSession(cookieBasedSession) === true) {// todo maybe switch this with session_duration_threshold
                    this.logger.info(this.log_prefix, "was able to resolve user session from cookie, time to live[", ttl, "]");
                    return callback(null, true, cookieBasedSession);
                } else {
                    this.logger.info(this.log_prefix, "could not resolved user session from cookie - session outdated[", ttl, "]");
                    return callback(null, false, cookieSession);
                }
            });
        } else {
            this.logger.info(lp, "called with invalid cookie token string");
            return callback(null, false, cookieSession);
        }
    }

    private writeCookie(token: string, expiryDate: Date): void {
        let lp = this.log_prefix + "writeCookie:";

        if (token != null) {
            this.cookieService.set(default_name, token, expiryDate, default_domain);
        }
    }

    /**
     * Function to streamline access to a userBearerToken stored in a cookie
     * @return {string} will be empty or hold a userBearerToken
     */
    public getUserBearerTokenFromCookie(): string {
        let token = this.cookieService.get(default_name) || "";
        return token;
    }

    public logOut(): void {
        this.logger.info(this.log_prefix,"user logout requested");
        this.cookieService.delete('userBearerToken');
        this.haveUserInServiceSubject.next(false);
        this.http.get<UserLogOutRequest>(this.bes.getBackendUserLogOutUrl(), this.setupHttpOpts(this.userSession)).subscribe(logOutResponse => {
            this.logger.info("logout request responded:", Object.keys(logOutResponse), logOutResponse);
            this.user = null;
            this.userEmitter.emit(null);
            this.haveUserInServiceSubject.next(false);
            this.unsureIfHaveUser = true;
        });
    }

    private setupHttpOpts(userSession: UserSession): HttpOptions {

        this.httpOptions = new HttpOptions(userSession);
        return this.httpOptions;
    }

    private getCurrentUserWithUserSession(callback: Function): void {
        let lp = this.log_prefix + " getCurrentUserWithUserSession:";

        this.logger.info(lp,"called: ttl:",this.userSession.ttl);
        this.setupHttpOpts(this.userSession);
        this.http.get<GetCurrentUserResponse>(this.bes.getBackendGetCurrentUserUrl(), this.httpOptions).subscribe(getCurrentUserResponse => {
            let {data} = getCurrentUserResponse;
            let {user_id} = data;
            let {user_name} = data;
            let {user_is_verified} = data;
            let {user_email} = data;
            let {user_homepage} = data;
            // let {user_has_extended_info} = data;
            // let {user_has_custom_settings} = data;
            // let {user_has_agreed_to_cookie_usage} = data;
            // let {user_email_has_been_verified} = data;
            let {user_avatar} = data;
            let {user_country} = data;
            let {user_city} = data;
            let {user_zip} = data;
            let {user_status} = data;
            let {user_settings} = data;


            let {test} = user_settings;
            let {isDefault} = user_settings;
            let {user_level} = user_settings;
            let {follow_notification} = user_settings;
            let {comment_notification} = user_settings;
            let {newboard_notification} = user_settings;
            let {show_social_media_accounts_on_profile} = user_settings;
            let {privat_profil_privacy} = user_settings;
            let {send_messages_privacy} = user_settings;
            let {created_at} = user_settings;

            let settings = new UserSettings(isDefault, user_level, follow_notification, comment_notification, newboard_notification, show_social_media_accounts_on_profile, privat_profil_privacy, send_messages_privacy, created_at);
            let user = new User(user_id, user_name, user_avatar, user_is_verified, user_email, user_homepage, user_country, user_city, user_zip, user_status, settings);
            // this.logger.info(lp,"created user from session:",user)
            return callback(null, user);
        }, error => {
            this.logger.warn(lp,"failure to get current user via userSession");
            return callback(error);
        });
    }

    public getUserEmitter(): EventEmitter < User > {
        return this.userEmitter;
    }

    public getUserSubject(): Subject < User > {
        if(this.haveValidUserInService() === true){
            this.logger.info(this.log_prefix, "already have local user[", this.user.user_id, "] in service -> remitting");
            this.redirect_in_case_of_known_user();
            this.reEmitResolvedUser();

        } else {
            this.logger.info(this.log_prefix, "dont have user yet");
            this.redirect_in_case_of_anon_user();
        }
        return this.userSubject;
    }

    public getUserSessionSubject(): Subject < UserSession > {
        return this.userSessionSubject;
    }

    public getUserExistsInServiceSubject(): Subject < boolean > {
        return this.haveUserInServiceSubject;
    }

    public getUserSessionBasedHttpOptionsAsSubject(): Subject < HttpOptions > {
        return this.backendHttpOptionsSubject;
    }

    public serviceInterfaceToInformOfChanges():Subject <string>{
        return this.changeDetectionSubject;
    }

    public getCurrentHttpOptionsForBackend():HttpOptions{
        return this.httpOptions;
    }

    private reEmitResolvedUser(): void {
        if (this.user != null) {
            this.logger.info(this.log_prefix, "remit called -> sending user [", this.user.user_id, "] / user name [",this.user.user_name,"]");
            setTimeout(() => {
                this.userSubject.next(this.user);
            }, 50);

        } else {
            this.logger.info(this.log_prefix, "remit called before user was resolved");
        }
    }

    public getUserForComponent(): any {
        if (this.user != null) {
            this.logger.info(this.log_prefix, "sending user:", this.user);

            return this.user;
        } else {
            this.logger.info(this.log_prefix, "dont have user, sending null/[", this.user, "]");
        }

    }

    private haveUserInServiceAndRedirect(): boolean {
        this.logger.info(this.log_prefix,"you are at[", this.router.url, "]", this.haveValidUserInService(),"sure:",this.unsureIfHaveUser);

        if(this.unsureIfHaveUser === false){
            if (this.haveValidUserInService() === true) {
                // this.logger.info(this.log_prefix, "have user in service: uid:", this.user.user_id);
                if (this.user.user_id != -1) {
                    this.redirect_in_case_of_known_user();
                    return true;
                } else {
                    if(this.userSession != null && this.userSession.ttl > 0){
                        this.logger.info(this.log_prefix,"dont have user yet, but have valid user session");
                        this.redirect_in_case_of_known_user();
                        return true;
                    } else {
                        this.logger.info(this.log_prefix,"redirecting anon user",this.userSession);
                        this.redirect_in_case_of_anon_user();
                        return false;
                    }
                }
            } else {
                this.logger.info(this.log_prefix, "could not reliably determine user, please relogin");
                this.redirect_in_case_of_anon_user();
                return false;
            }
            return false;
        } else {
            this.logger.info(this.log_prefix,"unsure if we have determined user or not :)");
            this.redirect_in_case_of_anon_user();
        }

        return false;
    }

    private redirect_in_case_of_known_user(): void {
        switch (this.router.url) {

            case '/login': {
            }
            case '/': {
                this.logger.info(this.log_prefix, "redirecting to dashboard");
                this.router.navigate(['/u']);
            }
            default: {
                break
            }
        }
    }

    private redirect_in_case_of_anon_user(): void {
        switch (this.router.url) {

            case '/settings': {
            }
            case '/p': {
            }
            case '/u': {
                this.logger.info(this.log_prefix, "redirecting to login");
                this.router.navigate(['/login']);
            }
            case '/create': {
                this.router.navigate(['/login']);
            }
            default: {
                break
            }
        }
    }

    public registerAndLogInWithOAuth(user:SocialUser,callback:Function){
        let lp = this.log_prefix+"registerAndLogInWithOAuth:";
        let userLoginObservable:Observable<UserSession> = new Observable<UserSession>((observer)=>{
            // let requestInput = {
            //
            // }
            this.http.post<UserSession>(this.bes.getBackendUserRegisterOrLoginWithOAuthUrl(), user).subscribe(userSession => {
                    let parsedSession = new UserSession(userSession);

                    this.writeCookie(userSession.token, new Date(userSession.expire));
                    this.userSession = new UserSession({ token:parsedSession.token, expire: parsedSession.expire, ttl: parsedSession.ttl});
                    this.unsureIfHaveUser = false;
                    this.resolveUserFromUserSession();
                    this.haveUserInServiceSubject.next(true); // maybe already obsolete, or move to resolve user from user session

                    //this.router.navigate(["/dashboard"]);
                    observer.next(parsedSession);
                },
                error => {
                    callback(error);
                });
        });
        return userLoginObservable;
    }
}
